import { openFolderSelector, closeFolderSelector } from '../actions/internalActions';
import { mutator } from 'satcheljs';
import { getStore } from '../store/store';

mutator(openFolderSelector, () => {
    getStore().isOpen = true;
});

mutator(closeFolderSelector, () => {
    getStore().isOpen = false;
});
